import { Article } from '../types';

class RelatedArticlesRepository extends ArticleRepository<Article> {
  getMany(id: string) {
    return this._getMany({ url: '/articles/related', query: { articleId: id }, cache: 'always' });
  }
}

export const relatedArticlesRepository = new RelatedArticlesRepository();
